import {
  EmptyResponse,
  MyWeatherSyncRequest,
  MyWeatherSyncResponse,
  SavedPlace,
  SavedPlaceInput,
  SavedPlaceUpdate,
  TypedApiRequestParams,
} from '../types';

// Saved places and the My weather sync (backend#266). The trailing slashes
// are required: DRF redirects the slash-less form, and the redirect drops
// a POST body.
const PLACES_URL = 'user/places/';

const listPlaces = (): TypedApiRequestParams<SavedPlace[]> => ({
  url: PLACES_URL,
  method: 'GET',
  authRequired: true,
});

/** 201 for a new place, 200 with the existing one if it was saved before. */
const createPlace = (
  place: SavedPlaceInput,
): TypedApiRequestParams<SavedPlace> => ({
  url: PLACES_URL,
  method: 'POST',
  params: place,
  authRequired: true,
});

const updatePlace = (
  id: string,
  changes: SavedPlaceUpdate,
): TypedApiRequestParams<SavedPlace> => ({
  url: `${PLACES_URL}${id}/`,
  method: 'PATCH',
  params: changes,
  authRequired: true,
});

/** Also removes the place from the account's My weather order. */
const deletePlace = (id: string): TypedApiRequestParams<EmptyResponse> => ({
  url: `${PLACES_URL}${id}/`,
  method: 'DELETE',
  authRequired: true,
});

const syncMyWeather = (
  body: MyWeatherSyncRequest,
): TypedApiRequestParams<MyWeatherSyncResponse> => ({
  url: 'user/my-weather/sync/',
  method: 'POST',
  params: body,
  authRequired: true,
});

export default {
  listPlaces,
  createPlace,
  updatePlace,
  deletePlace,
  syncMyWeather,
};
